import { selectBudgetDrawingByDiff } from '@/services/order'
import { Anchor, Spin } from 'antd'
import { useEffect, useRef, useState } from 'react'
import { SGeneralForms } from 'shj-components'
import styles from './index.module.less'
import drawingManagementConfig from './config'

const keyToCodeMap = {
  'drawing-desc': 'drawDesc',
  'drawing-origin': 'origin',
  'drawing-demolition': 'unknit',
  'drawing-ground': 'ground',
  'drawing-ceiling': 'top',
  'drawing-electricity': 'waterElectric',
  'drawing-elevation': 'facade',
  'drawing-other': 'other',
  'drawing-source': 'source',
}

export default function DrawingManagement(props) {
  const formRef = useRef<any>()
  const [activeAnchor, setActiveAnchor] = useState('drawing-desc')
  const containerRef = useRef<HTMLDivElement>(null)
  const [pageLoading, setPageLoading] = useState(false)
  const [updateMap, setUpdateMap] = useState({});
  const [anchorList, setAnchorList] = useState([
    {
      key: 'drawing-desc',
      href: '#drawing-desc',
      title: '图纸说明',
    },
    {
      key: 'drawing-origin',
      href: '#drawing-origin',
      title: '原始类施工图',
    },
    {
      key: 'drawing-demolition',
      href: '#drawing-demolition',
      title: '拆改类施工图',
    },
    {
      key: 'drawing-ground',
      href: '#drawing-ground',
      title: '地面类施工图',
    },
    {
      key: 'drawing-ceiling',
      href: '#drawing-ceiling',
      title: '顶面类施工图',
    },
    {
      key: 'drawing-electricity',
      href: '#drawing-electricity',
      title: '水电类施工图',
    },
    {
      key: 'drawing-elevation',
      href: '#drawing-elevation',
      title: '立面类施工图',
    },
    {
      key: 'drawing-other',
      href: '#drawing-other',
      title: '其他类施工图',
    },
    {
      key: 'drawing-source',
      href: '#drawing-source',
      title: '源文件',
    },
  ])

  useEffect(() => {
    // 查询图纸
    getData()
  }, [])

  // 监听滚动更新锚点
  useEffect(() => {
    const handleScroll = () => {
      const scrollContainer = containerRef.current
      if (!scrollContainer) return

      // 获取所有锚点
      const sections = document.querySelectorAll('[id^="drawing-"]')

      // 遍历所有锚点，找到当前锚点
      sections.forEach(section => {
        const element = section as HTMLElement
        const rect = element.getBoundingClientRect()
        // 判断距离，如果锚点在可视区域内，则设置为当前锚点
        if (rect.top <= 350) {
          setActiveAnchor(element.id)
        }
      })
    }

    // 使用 containerRef 作为滚动容器
    const scrollContainer = containerRef.current
    if (scrollContainer) {
      scrollContainer.addEventListener('scroll', handleScroll, { passive: true })

      // 初始化时执行一次
      handleScroll()

      return () => {
        scrollContainer.removeEventListener('scroll', handleScroll)
      }
    }
  }, [])


  // 获取图纸信息
  const getData = async () => {
    setPageLoading(true)
    selectBudgetDrawingByDiff({
      quoteBudgetId: props?.quoteBudgetId,
      quotationFlowId:  props?.quotationFlowId,
    })
      .then((res: any) => {
        // 转换数组数据为表单值
        const formattedData = res.reduce(
          (acc, item) => {
            const { nameCode, urlList } = item

            // 转换每个 URL 为文件对象
            const fileList = urlList.map((url, index) => ({
              uid: `${nameCode}-${index}`,
              status: 'done',
              url: url,
              thumbUrl: url,
              name: url.split('/').pop(),
              response: {
                data: { fileUrl: url }, // 保持与上传时的数据结构一致
              },
            }))

            acc[nameCode] = fileList
            return acc
          },
          {} as Record<string, any>
        )

        // 使用 formRef 设置表单值
        formRef.current?.onFormRef().setFieldsValue(formattedData)

        const updateMap = {};
        const updateNameMap = {};
        res.forEach(item => {
          if (item?.updateType === 'UPDATE') {
            updateMap[item?.typeCode] = true
            updateNameMap[item?.nameCode] = true
          }
        })
        setUpdateMap(updateNameMap)
        const newAnchorList: any = anchorList?.map(anchor => {
          if (updateMap?.[keyToCodeMap?.[anchor?.key]]) {
            return {
              ...anchor,
              title: (<span style={{ color: 'red' }}>{ anchor?.title }</span>)
            }
          }
          return {
            ...anchor
          }
        })
        setAnchorList(newAnchorList);
      })
      .finally(() => {
        setPageLoading(false)
      })
  }

  // 点击锚点
  const handleAnchorClick = (event: any, link: any) => {
    // 阻止默认行为
    event.preventDefault()
    setCurrentAnchorFn(link.href.split('#')[1]);
  }
  // 设置锚点
  const setCurrentAnchorFn = (anchorName: string) => {
    // 获取锚点元素
    const targetElement = document.getElementById(anchorName);
    if (targetElement) {
        // 滚动到锚点元素
        targetElement.scrollIntoView({behavior: 'smooth'})
        // 设置当前锚点
        setActiveAnchor(anchorName)
    }
  }

  return (
    <Spin spinning={pageLoading} wrapperClassName={styles.spinWrapper}>
      <div
        ref={containerRef}
        style={{
          display: 'flex',
          backgroundColor: '#fff',
          marginTop: '10px'
        }}
      >
        {/* 左侧锚点 */}
        <div
          style={{
            width: 150,
            marginRight: 20,
            position: 'sticky',
            top: 0,
            height: 'fit-content',
            alignSelf: 'flex-start',
          }}
        >
          <Anchor
            offsetTop={100}
            affix={false}
            getCurrentAnchor={() => `#${activeAnchor}`}
            onClick={handleAnchorClick}
            items={anchorList}
          />
        </div>

        {/* 右侧表单内容 */}
        <div
          style={{
            flex: 1,
            paddingRight: '20px',
          }}
        >
          <SGeneralForms
            ref={formRef}
            layout={'vertical'}
            configs={drawingManagementConfig({status: '', updateMap})}
            formConfig={{
              onValuesChange: () => {},
            }}
          />
        </div>
      </div>
    </Spin>
  )
}
